import React from 'react';

import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

import { Articles, Home, Article, Error } from '../views';

import { Provider } from 'react-redux';

import store from '../store';

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Header />
        <Routes>
          <Route path="/articles/:year/:month/:uid" element={<Article />} />
          <Route path="/articles/:year/:month" element={<Articles />} />
          <Route path="/articles/:year" element={<Articles />} />
          <Route path={'/articles'} element={<Articles />} />
          <Route path={'/'} element={<Home />} />
          <Route path={'*'} element={<Error />} />
        </Routes>
        <Footer />
      </Router>
    </Provider>
  );
};
export default App;
